export default {
	"offer.readMore": "mehr erfahren",
} as const;
